import { createContext, useContext } from "react";
import { ChatSession, Message } from "../interfaces/Chat";

interface ChatSessionsContextType {
  chatSessions: ChatSession[];
  updateSelectedChatSession: (chatSessionId: string) => void;
  addNewChatSession: (question?: string) => string;
  updateNewChatSession: (question: string) => void;
  resetSelectedChatSession: () => void;
  setChatSessions: any;
  selectedChatSession: string | null | undefined;
  messages: Message[];
  setMessages: any;
  noMsgReset: React.MutableRefObject<boolean>;
  filterCourseType: string | null;
  setFilterCourseType: (courseType: string | null) => void;
  mobileOpen: boolean;
  handleDrawerToggle: () => void;
  handleDrawerTransitionEnd: () => void;
  handleDrawerClose: () => void;
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
}

const ChatSessionsContext = createContext<ChatSessionsContextType | undefined>(
  undefined
);

export function useChatSessionsContext() {
  const context = useContext(ChatSessionsContext);
  if (context === undefined) {
    throw new Error();
  }
  return context;
}

export default ChatSessionsContext;
